import { Outlet } from 'react-router-dom'
import DashboardHeader from '../../Compnents/Main/DashboardHeader'

const DashboardLayout = () => {
    return (
        <>
            <DashboardHeader />
            <Outlet />
        </>
    )
}

export default DashboardLayout